/* co-scripts-global — small site-wide behaviours (loaded deferred on every page). */

/* Contact-form "message sent" toast.
   The contact form submits natively (the store's spam protection requires the CAPTCHA token only a
   native submit provides), and after the CAPTCHA Shopify redirects to the REFERRING page with
   ?contact_posted=true appended — but when the referrer is missing (common on preview domains, some
   in-app browsers) it lands on the HOME page instead, so the visitor never sees the contact page's
   inline success note and doesn't know the message went through. This watches every page for that
   contact_posted=true flag and shows a brand-styled confirmation toast wherever the visitor lands,
   then cleans the param out of the URL. On the contact page itself the inline note already renders,
   so the toast is skipped there. */
(function () {
  if (!/[?&]contact_posted=true/.test(window.location.search)) return;

  // Tidy the URL so refresh/share/back doesn't re-trigger the toast.
  try {
    var url = new URL(window.location.href);
    url.searchParams.delete('contact_posted');
    window.history.replaceState({}, '', url.pathname + (url.searchParams.toString() ? '?' + url.searchParams.toString() : '') + url.hash);
  } catch (e) {
    /* non-critical */
  }

  function showToast() {
    // The contact page renders its own inline success note — don't double up.
    if (document.querySelector('.co-contact-note--ok')) return;

    var toast = document.createElement('div');
    toast.className = 'co-form-toast co-dm';
    toast.setAttribute('role', 'status');
    toast.innerHTML =
      '<span class="co-form-toast-text">Thanks — your message has been sent! We’ll be in touch soon.</span>' +
      '<button type="button" class="co-form-toast-close" aria-label="Dismiss">&times;</button>';
    document.body.appendChild(toast);

    // On shopifypreview.com links Shopify injects a fixed bottom bar ("TPF/main · Draft") that covers a
    // bottom-anchored toast — lift the toast above it when present. It doesn't exist on the live site
    // (toast stays at its normal 24px) and it's injected async, so re-measure once shortly after.
    var clearBar = function () {
      var bar = document.querySelector('#PBarNextFrameWrapper, #preview-bar-iframe, iframe[src*="preview-bar"]');
      if (!bar) return;
      var h = bar.getBoundingClientRect().height;
      if (h > 0) toast.style.bottom = 24 + h + 'px';
    };
    clearBar();
    setTimeout(clearBar, 600);

    var remove = function () {
      toast.classList.add('co-form-toast--out');
      setTimeout(function () { toast.remove(); }, 350);
    };
    toast.querySelector('.co-form-toast-close').addEventListener('click', remove);
    setTimeout(remove, 9000); // long enough to read; dismissible sooner
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', showToast);
  } else {
    showToast();
  }
})();

/* Newsletter "subscribed" toast — same pattern as the contact toast above. The footer email signup
   is a native Shopify customer form (CAPTCHA-protected, so it can't be AJAX'd) whose post-submit
   redirect appends ?customer_posted=true — and, like the contact form, can land on the HOME page when
   the referrer is missing, leaving the visitor scrolled away from the footer's inline success note.
   Show a confirmation toast wherever they land; skipped when the footer's own inline success message
   is on the page (normal same-page landing), and the param is cleaned from the URL either way. */
(function () {
  // co_subscribed=1 is set by the footer form's return_to (our flag); customer_posted=true is
  // Shopify's own flag, kept as a fallback in case it lands appended too.
  if (!/[?&](co_subscribed=1|customer_posted=true)/.test(window.location.search)) return;

  try {
    var url = new URL(window.location.href);
    url.searchParams.delete('co_subscribed');
    url.searchParams.delete('customer_posted');
    window.history.replaceState({}, '', url.pathname + (url.searchParams.toString() ? '?' + url.searchParams.toString() : '') + url.hash);
  } catch (e) {
    /* non-critical */
  }

  function showToast() {

    var toast = document.createElement('div');
    toast.className = 'co-form-toast co-dm';
    toast.setAttribute('role', 'status');
    toast.innerHTML =
      '<span class="co-form-toast-text">Woof! You\u2019re subscribed \u2014 thanks for joining!</span>' +
      '<button type="button" class="co-form-toast-close" aria-label="Dismiss">&times;</button>';
    document.body.appendChild(toast);

    var clearBar = function () {
      var bar = document.querySelector('#PBarNextFrameWrapper, #preview-bar-iframe, iframe[src*="preview-bar"]');
      if (!bar) return;
      var h = bar.getBoundingClientRect().height;
      if (h > 0) toast.style.bottom = 24 + h + 'px';
    };
    clearBar();
    setTimeout(clearBar, 600);

    var remove = function () {
      toast.classList.add('co-form-toast--out');
      setTimeout(function () { toast.remove(); }, 350);
    };
    toast.querySelector('.co-form-toast-close').addEventListener('click', remove);
    setTimeout(remove, 9000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', showToast);
  } else {
    showToast();
  }
})();

/* Bundler app bridge — keep the cart drawer and Bundler's discount display in sync, BOTH ways.

   Direction 1 (theme → Bundler): the theme mutates the cart with fetch(), but the Bundler app only
   patches XMLHttpRequest to detect cart changes — so it never notices our adds/updates, and the drawer
   total stays undiscounted until a full page reload. The theme dispatches a bubbling 'cart:update'
   event for every cart mutation (component-cart-items.js), so re-broadcast it as
   'bndlr:cart_was_modified' — the event Bundler's own cart-display logic listens for. Fired twice:
   once after the synchronous drawer morph settles, and again later for listeners that re-render via an
   async section fetch (Bundler's handler is idempotent, so the double fire is harmless).

   Direction 2 (Bundler → theme): when Bundler itself adds to the cart (its "Save 10%!" tier buttons
   use its own XHR), the THEME doesn't know, so the drawer shows a stale cart until reload. Bundler's
   XHR hook dispatches 'bndlr:cart_was_modified' for its own cart calls — listen for those (ours carry
   detail.co so they're skipped: no loops) and re-render the header section (drawer + cart-count
   bubble), then let Bundler rewrite the freshly-morphed total. */
(function () {
  if (window.__coBundlerBridge) return;
  window.__coBundlerBridge = true;

  var notify = function () {
    document.dispatchEvent(new CustomEvent('bndlr:cart_was_modified', { detail: { co: 1 } }));
  };
  var onCartChange = function () {
    setTimeout(notify, 250);
    setTimeout(notify, 1200);
  };
  document.addEventListener('cart:update', onCartChange);
  document.addEventListener('discount:update', onCartChange);

  var refreshing = false;
  document.addEventListener('bndlr:cart_was_modified', function (event) {
    if (event.detail && event.detail.co) return; // our own re-broadcast (direction 1)
    if (refreshing) return;
    var cartItems = document.querySelector('cart-items-component');
    var sectionId = cartItems && (cartItems.getAttribute('data-section-id') || cartItems.sectionId);
    if (!window.sectionRenderer || !sectionId) return;
    refreshing = true;
    window.sectionRenderer
      .renderSection(sectionId, { cache: false })
      .then(function () { setTimeout(notify, 150); }) // Bundler re-writes the fresh drawer total
      .finally(function () { setTimeout(function () { refreshing = false; }, 500); });
  });
})();

/* (Removed 2026-08: the Instafeed wheel-scroll bridge. It mapped horizontal wheel/trackpad
   intent onto synthetic clicks of the app's own prev/next arrows. The SI Instafeed app has
   since switched to a drag/marquee slider that renders NO arrow buttons, so the bridge could
   never fire — and the app's native drag covers the interaction. If the app is ever switched
   back to an arrow layout and wheel support is wanted again, see git history for the
   implementation, or reuse assets/co-flickity-wheel.js as the model.) */
